import { useMutation, useQueryClient } from "@tanstack/react-query";
import { uploadDocuments } from "../OrderService";
import { ORDER_DETAILS_QUERY_KEY } from "./useOrderDetails";
import { showToast } from "../../../../common/Toaster/Toaster";

/**
 * TanStack Query Mutation hook to update order and automatically
 * trigger the read API to refresh order state (OEM ID, KYC status, etc.)
 */
export const useUpdateOrder = (orderId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      entityid,
      entitytype = "ODR",
      formState,
      variantState,
      currentState,
      finalPremium,
      coverAmount,
      orderType,
    }) => {
      return await uploadDocuments(
        entityid,
        entitytype,
        entityid,
        formState,
        variantState,
        currentState,
        finalPremium,
        coverAmount,
        orderId || entityid,
        orderType
      );
    },
    onSuccess: async (data) => {
      const idToFetch = orderId || data?.entityid;
      if (idToFetch) {
        // Invalidate and refetch the unique query key for order details
        await queryClient.invalidateQueries({
          queryKey: ORDER_DETAILS_QUERY_KEY(idToFetch),
        });
        await queryClient.refetchQueries({
          queryKey: ORDER_DETAILS_QUERY_KEY(idToFetch),
        });
      }
      queryClient.invalidateQueries({
        queryKey: ["orderListing"],
      });
    },
    onError: (error) => {
      const msg =
        error?.response?.data?.error_message || "Error while updating order";
      showToast(msg, "error");
    },
  });
};

export default useUpdateOrder;
